import React from 'react';
import { Button } from 'antd';
import { LogOut } from 'lucide-react';
import { H } from './design-tokens';
import { dimensions } from '../theme';
import { useResponsiveSizes } from '../../hooks/use-responsive-sizes';
import { ModuleDropdown } from './module-dropdown';
import { type PlatformModule } from './platform-header';

const { size } = dimensions;

interface HeaderDesktopActionsProps {
  navItems?: React.ReactNode;
  extraActions?: React.ReactNode;
  modules: PlatformModule[];
  activeModule: string;
  onModuleChange: (moduleId: string) => void;
  onSignOut: () => void;
}

export const HeaderDesktopActions: React.FC<HeaderDesktopActionsProps> = ({
  navItems,
  extraActions,
  modules,
  activeModule,
  onModuleChange,
  onSignOut
}) => {
  const { spacing } = useResponsiveSizes();
  const activeModuleDef = modules.find(m => m.id === activeModule);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: spacing.xs,
        flexShrink: 0,
        margin: `0 ${spacing.xxl}px`
      }}
    >
      {navItems}
      {extraActions}

      {activeModuleDef && modules.length > 1 && (
        <ModuleDropdown
          modules={modules}
          activeModule={activeModule}
          activeLabel={activeModuleDef.label}
          onModuleChange={onModuleChange}
        />
      )}

      <Button
        type='text'
        icon={<LogOut size={size.iconMd} />}
        onClick={onSignOut}
        style={{ color: H.textMuted, padding: '0 6px' }}
      />
    </div>
  );
};
